export * from "./stackPacks/StackPacksRoute";

export const VIEW_MODE_OVERVIEW = "overview" as const;
export const VIEW_MODE_HIGHLIGHTS = "highlights" as const;
export const VIEW_MODE_TOPOLOGY = "topology" as const;
export const VIEW_MODE_EVENTS = "events" as const;
export const VIEW_MODE_METRICS = "metrics" as const;
export const VIEW_MODE_TRACES = "traces" as const;

export const COMMON_VIEW_MODES = [VIEW_MODE_TOPOLOGY, VIEW_MODE_EVENTS] as const;

const ALL_VIEW_MODES = [
	...COMMON_VIEW_MODES,
	VIEW_MODE_HIGHLIGHTS,
	VIEW_MODE_OVERVIEW,
	VIEW_MODE_METRICS,
	VIEW_MODE_TRACES,
] as const;

export type CommonViewMode = (typeof COMMON_VIEW_MODES)[number];

export type ViewMode = (typeof ALL_VIEW_MODES)[number];

const VIEW_MODES_FRAGMENT = `${VIEW_MODE_OVERVIEW}|${VIEW_MODE_TOPOLOGY}|${VIEW_MODE_EVENTS}` as const;

/**
 * A component has a highlights mode, but does not have an overview mode.
 * A component's subview does not have the highlights mode, but does have the overview mode.
 * This is why the both are present here.
 */
const COMPONENT_MODES_FRAGMENT =
	`${VIEW_MODE_HIGHLIGHTS}|${VIEW_MODE_METRICS}|${VIEW_MODE_TRACES}|${VIEW_MODES_FRAGMENT}` as const;

export const COMPONENT_PATH = `/components/:identifier/:mode(${COMPONENT_MODES_FRAGMENT})?` as const;

export const VIEWS_OVERVIEW_PATH = "/views";
export const VIEW_PATH = `/views/:slug/:mode(${VIEW_MODES_FRAGMENT})?` as const;

export const DASHBOARDS_OVERVIEW_PATH = "/dashboards";
export const DASHBOARD_PATH = "/dashboards/:idOrIdentifier";

export const ANALYTICS_PATH = "/analytics";
export const MONITORS_PATH = "/monitors/:id?/:monitorFunctionIdentifier?" as const;
export const SETTINGS_PATH = "/settings/:name?/:id(new|\\d+)?";
export const ASSUME_ROLE_PATH = "/assumeRole";
export const CLIPROFILE_PATH = "/cli";
export const WELCOME_PATH = "/welcome";
export const METRICS_PATH = "/metrics";
export const TRACES_PATH = "/traces";
export const NOTIFICATIONS_PATH = "/notifications/:id?";

export const SESSIONS_PATH = "/sessions";
export const KUBERNETES_OVERVIEW_PATH = "/k8s";
